import React, { useContext, useState, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { LoadingContext, M_Table, NavigateContext, M_MovementFilter, BufferService } from 'src/M_Components'
import { MovementGroupDialog } from './movementGroupDialog'

export const RangeMovementList = ({ roles }) => {
    const { t } = useTranslation()
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)

    const [activeFilter, setActiveFilter] = useState('')
    const [refresh, setRefresh] = useState(false)
    const [selectedMovements, setSelectedMovements] = useState([])
    const [showGroupDialog, setShowGroupDialog] = useState(false)

    const movementService = new BufferService('Movement', 'secondary')

    const isFirstRender = useRef(true)
    useEffect(() => {
        if (isFirstRender.current) { isFirstRender.current = false; return }
        setRefresh(true)
    }, [activeFilter])

    const newRoute = (url, operation, label, row) => {
        if (operation === 'Edit' || operation === 'Copy') {
            if (row) {
                sessionStorage.setItem('editingMovement', JSON.stringify(row))
                sessionStorage.setItem('operationType', operation)
            } else {
                return
            }
        }
        if (operation === 'Create') ctx.setPassValues({ Operation: operation })
        ctx2.newTab(url, label)
    }

    const handleDelete = async (rows) => {
        if (!rows || rows.length === 0) {
            ctx.toastMessages('error', '', t('SelectedLine'))
            return
        }
        ctx.setIsLoad(true)
        for (const row of rows) {
            const res = await movementService.delete(row.Id)
            if (res?.name === 'AxiosError') {
                ctx.setIsLoad(false)
                const message = res.response?.data?.detail
                    || res.response?.data?.Message
                    || res.message
                    || t('Error')
                ctx.toastMessages('error', message, '')
                return
            }
        }
        ctx.setIsLoad(false)
        ctx.toastMessages('success', '', t('RemoveLine'))
        setRefresh(true)
    }

    const handleChangeGroupMovement = (rows) => {
        if (!rows || rows.length < 2) {
            ctx.toastMessages('error', '', t('Please select at least 2 movement rows for group update'))
            return
        }
        setSelectedMovements(rows)
        setShowGroupDialog(true)
    }

    const handleGroupSuccess = () => {
        setRefresh(true)
    }

    return (
        <>
            <M_Table
                entityName={'Movement'}
                api='secondary'
                showTitle={true}
                title={'Range Movements'}
                roleName={'usersGroups'}
                rolePermissions={roles}
                refresh={refresh}
                setRefresh={setRefresh}
                filterComponent={<M_MovementFilter onFilterChange={setActiveFilter} />}
                replaceFunctions={new Map([
                    ['Create', (row) => newRoute('containerControl/lastMovementCrud', 'Create', t('Add') + ' ' + t('Movement'), row)],
                    ['Edit',   (row) => newRoute('containerControl/lastMovementCrud', 'Edit',   t('Edit') + ' ' + t('Movement'), row)],
                    ['Copy',   (row) => newRoute('containerControl/lastMovementCrud', 'Copy',   t('Copy') + ' ' + t('Movement'), row)],
                    ['Delete', (rows) => handleDelete(rows)],
                    ['ChangeGroupMovement', (rows) => handleChangeGroupMovement(rows)],
                ])}
                FILTER={activeFilter || undefined}
            />

            <MovementGroupDialog
                open={showGroupDialog}
                setOpen={setShowGroupDialog}
                mode='update'
                selectedRows={selectedMovements}
                onSuccess={handleGroupSuccess}
            />
        </>
    )
}